<div class="common-up">
  <div class="modal-header d-flex align-items-center">
    <div>
      <h3 class="modal-title pb-3">{{header}}</h3>
      @if (materialNum) {
        <h5>Material # {{materialNum}}</h5>
      }
    </div>
    <button type="button" class="close" aria-label="Close" (click)="dismissModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  @if (!data) {
    <div class="modal-body float-left w-100 p-0">
      @if (!this.hasImage) {
        <div class="col-md-12 float-left mt-3">
          <p>{{message}}</p>
        </div>
      }
      @if (this.hasImage) {
        <img [src]='image' class="pdp-img" alt="Product image"/>
      }
    </div>
  }

  @if (data?.length) {
    <div class="hyperlink modal-body float-left w-100 p-0 mb-3">
      @for (item of data; track item) {
        <span>
          <a (click)="open(item?.orderNumber)" class="p-3">{{ item.orderNumber }} | {{ item.poNumber }}</a><br>
        </span>
      }
    </div>
  }
  @if (!this.hasImage) {
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="dismissModal()">Ok</button>
      <button type="button" class="btn btn-outline-primary" (click)="dismissModal()">Cancel</button>
    </div>
  }
</div>
